import React, { Component } from 'react';
import { scaleLinear } from 'd3-scale';
import { arc } from 'd3-shape';

import './_donutchart.scss';

let scale = scaleLinear()
  .domain([0, 1])
  .range([Math.PI * 1.2, Math.PI * 2.8]);

const CANVAS_SIZE = { default: 68, large: 162 };

// 1px gap: 1px → SVG units (×100/canvasPx) → radians (÷outerRadius 50)
const halfGapForSize = size => (100 / (CANVAS_SIZE[size] || CANVAS_SIZE.default)) / 50 / 2;

let segmentArc = arc()
  .innerRadius(50 - (12 / 68) * 100)
  .outerRadius(50)
  .startAngle(d => d[0])
  .endAngle(d => d[1]);

let outline = arc().innerRadius(50).outerRadius(50).startAngle(scale(0)).endAngle(scale(1));

export default class DonutChart extends Component {
  shouldComponentUpdate(nextProps) {
    return this.props.value !== nextProps.value || this.props.values !== nextProps.values;
  }

  render(props) {
    let className = 'donutchart';
    // TODO: Change 'type' to 'kind'
    if (props.type) {
      className += ' donutchart--' + props.type;
    }
    if (props.size) {
      className += ' donutchart--' + props.size;
    }

    const values = props.values || [props.value];
    const isMulti = props.values && values.length > 1;
    const halfGap = halfGapForSize(props.size);
    let cumulative = 0;
    const segments = values.map((value, i) => {
      const start = scale(cumulative);
      cumulative += value;
      const end = scale(cumulative);
      const startAngle = isMulti && i > 0 ? start + halfGap : start;
      const endAngle = isMulti && i < values.length - 1 ? end - halfGap : end;
      const colour = props.colours && props.colours[i];
      return (
        <path
          key={i}
          className="donutchart__fill"
          style={colour ? { fill: colour } : undefined}
          d={segmentArc([startAngle, endAngle])}
        />
      );
    });

    return (
      <div class={className}>
        <div className="donutchart__canvas">
          <svg viewBox="0 0 100 100" preserveAspectRatio="none">
            <g transform="translate(50, 50)">
              <path className="donutchart__outline" d={outline()} />
              {segments}
            </g>
          </svg>
          <p className="donutchart__value">{props.formattedValue}</p>
        </div>
        {props.title ? <p className="donutchart__title">{props.title}</p> : null}
      </div>
    );
  }
}
